import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-question-hint',
    templateUrl: './question-hint.component.html',
    styleUrls: ['./question-hint.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionHintComponent implements OnInit {
  @Input() hint: string;

  constructor() { }

  ngOnInit(): void {
  }

}
